import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Task } from '../../../../types/task.interface';
import { AbstractTemplateComponent } from '../../abstract/abstract-template.component';
import { Store } from '@ngrx/store';
import { CamundaService } from '../../../../service/camunda.service';
import { FluxBPMState } from '../../../../store/reducer/flux-bpm.reducers';
import { NgIf } from '@angular/common';

@Component({
    selector: 'lib-flux-background-task-step-template',
    templateUrl: './background-task-template.component.html',
    styleUrls: ['./background-task-template.component.scss'],
    imports: [NgIf],
    standalone: true
})
export class BackgroundTaskTemplateComponent extends AbstractTemplateComponent implements OnInit, OnDestroy {

    public showCancelButton = false;
    private cancelButtonTimeout: any = null;

    constructor(
        protected camundaService: CamundaService,
        protected store: Store<FluxBPMState>
    ) {
        super(camundaService, store);
    }

    public taskUpdated(): void {}

    ngOnInit(): void {
        this.config.showNextButton = false;
        super.onInit(false);

        // Set timeout to show cancel button after 3 seconds
        this.cancelButtonTimeout = setTimeout(() => {
            this.showCancelButton = true;
        }, 3000);
    }

    ngOnDestroy(): void {
        // Clear timeout if component is destroyed
        this.clearCancelButtonTimeout();
        super.ngOnDestroy();
    }

    nextTriggered(): void {
        // Clear timeout if process completes before 3 seconds
        this.clearCancelButtonTimeout();
    }

    private clearCancelButtonTimeout(): void {
        if (this.cancelButtonTimeout) {
            clearTimeout(this.cancelButtonTimeout);
            this.cancelButtonTimeout = null;
        }
    }

    cancelProcess(): void {
        if (this.cancelTrigger) {
            this.cancelTrigger.next(true);
        }
    }
}
